import { Components } from "@thisgorilla/primate-ds";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "styled-components";
import WaveSurfer from "wavesurfer.js";

import { FlexColumn, FlexRow } from "../Styles";
import AudioBarProps from "./AudioBar";
import Footer from "./Footer";
import { AudioBarContainer, BarHeading, TextContainer } from "./style";
import { Modal } from "../Modal";
import ShareModal from "./ShareModal";

const AudioBar = ({
  backgroundColor,
  title,
  description,
  url,
  isViewOnly,
}: AudioBarProps.IProps) => {
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const { typography } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isModalShareOpen, setIsModalShareOpen] = useState(false);
  const [wavesurfer, setWavesurfer] = useState<WaveSurfer | null>(null);

  useEffect(() => {
    if (ref?.current) {
      setHeight(ref.current.clientHeight);
    }
  }, [isOpen, description, title]);

  return (
    <>
      <AudioBarContainer $backgroundColor={backgroundColor}>
        <BarHeading>
          <FlexRow $gapInPx={8}>
            <div>
              <Components.IconButton
                kind="Secondary"
                iconType={isPlaying ? "Pause" : "Play"}
                disabled={false}
                size="Medium"
                onClick={() => {
                  wavesurfer && wavesurfer.playPause();
                }}
                IconButtonColor={"#F3F5F6"}
              />
            </div>
            <FlexColumn>
              <FlexRow>
                <Components.Icon type="BarChart2" size="24px" color="#F3F5F6" />
                <Components.Text
                  style={{ tokenStyle: typography.Heading.M }}
                  fontWeight="font-weight-semibold"
                  text={title}
                  color={"#F3F5F6"}
                  maxLineLength={1}
                />
              </FlexRow>
              <TextContainer $height={height}>
                <div ref={ref}>
                  <Components.Text
                    style={{ tokenStyle: typography.Body.S }}
                    fontWeight="font-weight-semibold"
                    text={description}
                    color={"#F3F5F6"}
                    maxLineLength={isOpen ? 20 : 1}
                    lineHeight="line-height-50"
                  />
                </div>
              </TextContainer>
            </FlexColumn>
          </FlexRow>
          <div>
            <Components.IconButton
              kind="Secondary"
              iconType={isOpen ? "ChevronUp" : "ChevronDown"}
              disabled={false}
              IconButtonColor={"#F3F5F6"}
              size="Medium"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            />
          </div>
        </BarHeading>
        <Footer
          wavesurfer={wavesurfer}
          setWavesurfer={setWavesurfer}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          url={url}
          setIsModalShareOpen={setIsModalShareOpen}
          isViewOnly={isViewOnly}
        />
      </AudioBarContainer>
      {isModalShareOpen && (
        <Modal
          from="default-post"
          type="Pages"
          maxWidth={456}
          closeModalOnClickOutside
          setCloseButton={setIsModalShareOpen}
          showCloseButton={true}
        >
          <ShareModal />
        </Modal>
      )}
    </>
  );
};

export default AudioBar;
